import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { SeverityPill } from '../Redesing/severity-pill';
import { getLocaleDateTimeString } from '../../utils';
import { IUnlockRow } from '../../util/unlockEvents';

function UnlockRow({ row }: { row: IUnlockRow }) {
  return (
    <TableRow
      sx={
        row.success
          ? undefined
          : { backgroundColor: (theme) => theme.palette.error.alpha12 }
      }
    >
      <TableCell>{getLocaleDateTimeString(row.timestamp)}</TableCell>
      <TableCell>
        <SeverityPill color={row.success ? 'success' : 'error'}>
          {row.success ? 'Success' : 'Failed'}
        </SeverityPill>
      </TableCell>
      <TableCell>
        {row.secondsToUnlock !== null ? `${row.secondsToUnlock.toFixed(1)}s` : '—'}
      </TableCell>
    </TableRow>
  );
}

/**
 * Table of unlock attempts for a single hardware unit, with failed attempts
 * highlighted in red. Shared by the rental and hardware detail Unlocks tabs.
 */
export function UnlockEventsTable({ rows }: { rows: IUnlockRow[] }) {
  return (
    <Table size="small" sx={{ mb: 2 }}>
      <TableHead>
        <TableRow>
          <TableCell>Time</TableCell>
          <TableCell>Result</TableCell>
          <TableCell>Time to Unlock</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row) => (
          <UnlockRow key={row.id} row={row} />
        ))}
      </TableBody>
    </Table>
  );
}
